// extracted by mini-css-extract-plugin
export const card = "SubscribeFormInfoCard-module--card--2SFnB";
export const title = "SubscribeFormInfoCard-module--title--1CJmu";
export const image = "SubscribeFormInfoCard-module--image--3HddJ";